"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMemberLeaderboardsPositionById = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns leaderboards statistics of a selected member.
 *
 * Member is identified by their Steam ID.
 *
 * ## Usage
 *
 * ```ts
 * const memberId: string = '6578987654567';
 * const memberLeaderboards: Leaderboards = await sdk.getMemberLeaderboardsPositionById({ memberId });
 * ```
 *
 * @param params.memberId - Steam ID of the member whose leaderboards position we want to check.
 */
const getMemberLeaderboardsPositionById = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { memberId } = params;
    const url = `${BASE_URL}/leaderboards/member/${memberId}`;
    const leaderboardsResponse = yield axios_1.default.get(url, { validateStatus: () => true });
    const { status, data } = leaderboardsResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getMemberLeaderboardsPositionById = getMemberLeaderboardsPositionById;
